export const UPLOADING_WORDS = [
  "Uploading",
  "Decanting",
  "Pipetting",
  "Aliquoting",
  "Pouring",
  "Dispensing",
  "Aspirating",
  "Loading",
  "Charging",
  "Funnelling",
  "Injecting",
  "Infusing",
  "Dissolving",
  "Suspending",
  "Diluting",
  "Emulsifying",
  "Homogenising",
  "Vortexing",
  "Stirring",
  "Swirling",
  "Agitating",
  "Mixing",
  "Blending",
  "Combining",
  "Compounding",
  "Saturating",
  "Diffusing",
  "Permeating",
  "Bubbling",
  "Aerating",
  "Nebulising",
  "Atomising",
  "Vaporising",
  "Sublimating",
  "Condensing",
  "Liquefying",
  "Solubilising",
  "Transferring",
  "Pumping",
  "Drawing",
  "Metering",
  "Sealing",
  "Stoppering",
  "Capping",
  "Weighing",
  "Tarring",
  "Filling",
  "Topping up",
  "Replenishing",
  "Plating",
  "Coating",
  "Layering",
  "Stacking",
  "Priming",
  "Equilibrating",
  "Mounting",
  "Coupling",
  "Bonding",
  "Clamping",
  "Activating",
  "Energising",
  "Initiating",
  "Igniting",
  "Sparking",
  "Refluxing",
  "Heating",
  "Cooling",
  "Chilling",
  "Freezing",
  "Thawing",
  "Adding",
  "Introducing",
  "Inoculating",
  "Spiking",
  "Doping",
  "Treating",
  "Sampling",
  "Buffering",
  "Sonicating",
  "Eluting",
  "Quenching",
  "Reacting",
  "Streaming",
  "Channelling",
  "Marshalling",
  "Stocking",
];

export const PROCESSING_WORDS = [
  "Processing",
  "Analysing",
  "Synthesising",
  "Catalysing",
  "Crystallising",
  "Precipitating",
  "Titrating",
  "Reducing",
  "Oxidising",
  "Hydrolysing",
  "Dehydrating",
  "Hydrating",
  "Ionising",
  "Polymerising",
  "Chelating",
  "Complexing",
  "Electrolysing",
  "Resolving",
  "Separating",
  "Fractionating",
  "Distilling",
  "Filtering",
  "Purifying",
  "Refining",
  "Recrystallising",
  "Evaporating",
  "Annealing",
  "Tempering",
  "Curing",
  "Inhibiting",
  "Denaturing",
  "Renaturing",
  "Folding",
  "Unfolding",
  "Cleaving",
  "Cross-linking",
  "Functionalising",
  "Substituting",
  "Neutralising",
  "Acidifying",
  "Alkalising",
  "Standardising",
  "Calibrating",
  "Normalising",
  "Quantifying",
  "Measuring",
  "Chromatographing",
  "Centrifuging",
  "Decanting",
  "Drying",
  "Boiling",
  "Extracting",
  "Identifying",
  "Characterising",
  "Detecting",
  "Diagnosing",
  "Validating",
  "Verifying",
  "Balancing",
  "Computing",
  "Calculating",
  "Modelling",
  "Probing",
  "Inspecting",
  "Examining",
  "Indexing",
  "Cataloguing",
  "Classifying",
  "Labelling",
  "Annotating",
  "Concentrating",
  "Decoding",
  "Mapping",
  "Plotting",
  "Charting",
  "Correlating",
  "Comparing",
  "Interpreting",
  "Reading",
  "Resolving",
  "Reconciling",
  "Aggregating",
  "Compiling",
  "Summarising",
  "Distilling",
  "Finalising",
];
